import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASSES = ["bg-accent", "rounded", "px-1.5", "py-0.5"]
const INACTIVE_CLASSES = ["opacity-70"]

export default class extends Controller {
  static values = { frameId: { type: String, default: "herb-results" } }

  connect() {
    this._frameRenderHandler = (event) => {
      if (event.target.id === this.frameIdValue) this.syncFromUrl()
    }
    document.addEventListener("turbo:frame-render", this._frameRenderHandler)
    this.syncFromUrl()
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this._frameRenderHandler)
  }

  setActive(event) {
    this._applyActive(event.currentTarget)
  }

  syncFromUrl() {
    const letter = new URLSearchParams(window.location.search).get("letter")?.toUpperCase()
    this.clearActive()
    if (letter) {
      const link = Array.from(this.element.querySelectorAll("a")).find(
        a => a.textContent.trim() === letter
      )
      if (link) this._applyActive(link)
    }
  }

  clearActive() {
    this.element.querySelectorAll("a").forEach(link => {
      link.classList.remove(...ACTIVE_CLASSES, ...INACTIVE_CLASSES)
    })
  }

  _applyActive(activeLink) {
    this.clearActive()
    activeLink.classList.add(...ACTIVE_CLASSES)
    this.element.querySelectorAll("a").forEach(link => {
      if (link !== activeLink) link.classList.add(...INACTIVE_CLASSES)
    })
  }
}
